"use strict"
/* Import CSS */
import "../scss/main.scss"
// Browser detection
import { detect } from "detect-browser"
window.browser = detect()
import "htmx.org"
import _hyperscript from "hyperscript.org"
window.htmx = require("htmx.org")
_hyperscript.browserInit()

import State from "./state"
import {
  accordion,
  autoOpenFirstAccordion,
  passwordVisibilityToggle,
  accordionWithCaret,
  accordionMobile,
  breakpoints,
  debounce,
  removeAccents,
  removeAccentsTest,
} from "./helpers"

/* Dynamic Imports JS */
import {
  getIolazy,
  getNavigation,
  getProductDetail,
  getFilters,
  getSwiper,
  getNotifications,
  getBasket,
  getWishlist,
  getCheckout,
  getDropdown,
  getGateway,
  getTooltip,
  getNotificationBar,
  getProduct,
  getBlurhash,
  getSubscribe,
  getPhotoSwipe,
  getLookbook,
  getHeaderNavigation,
} from "./dynamicImports"

import accessibleAutocomplete from "../../../node_modules/accessible-autocomplete/dist/accessible-autocomplete.min.js"
import PhotoSwipeLightbox from "photoswipe/lightbox"

const App = {
  initSwiper() {
    // Init swiper
    if (document.querySelector(".swiper.mostDesirables")) {
      getSwiper().then((method) => method.SwiperGallery.mostDesirables())
    }

    if (document.querySelector(".swiper.landingPage-range")) {
      getSwiper().then((method) => method.SwiperGallery.landingPageRange())
    }

    if (document.querySelector(".swiper.newNtrending")) {
      getSwiper().then((method) => method.SwiperGallery.newNtrending())
    }

    if (document.querySelector(".swiper.hero-slider")) {
      getSwiper().then((method) => method.SwiperGallery.heroSlider())
    }

    if (document.querySelector(".swiper.secondary-banner-slider")) {
      getSwiper().then((method) => method.SwiperGallery.secondaryBannerSlider())
    }

    if (document.querySelector(".swiper.homepage-categories")) {
      getSwiper().then((method) => method.SwiperGallery.homePageCategoriesSlider())
    }

    if (document.querySelector(".swiper.banner-carousel-1")) {
      getSwiper().then((method) => method.SwiperGallery.bannerCarousel1())
    }

    if (document.querySelector(".swiper.banner-carousel-2")) {
      getSwiper().then((method) => method.SwiperGallery.bannerCarousel2())
    }

    if (document.querySelector(".swiper.promotional-info-alt")) {
      getSwiper().then((method) => method.SwiperGallery.promoInfoBanner())
    }

    const recommendedGalleries = document.querySelectorAll(".swiper-container.recommended")
    if (recommendedGalleries && recommendedGalleries.length > 0) {
      getSwiper().then((method) => {
        if (!method?.SwiperGallery?.recommendedGallery) return
        recommendedGalleries.forEach((gallery) => method.SwiperGallery.recommendedGallery(gallery))
      })
    }

    if (document.querySelector(".swiper-container.shopByLook")) {
      getSwiper().then((method) => method.SwiperGallery.shopByLook())
    }

    if (document.querySelector(".swiper-container.post-related")) {
      getSwiper().then((method) => method.SwiperGallery.postRelatedGallery())
    }
    // const swiperComponents = document.querySelectorAll(".swiper-outer__component.toolbar-active")
    // if (swiperComponents && swiperComponents.length > 0) {
    //     swiperComponents.forEach((gallery, index) => {
    //         const swiperElement = gallery.querySelector(".swiper")
    //         getSwiper().then((method) => method.SwiperGallery.componentGallery(swiperElement, index))
    //     })
    // }

    // if (document.querySelector(".swiper.carousel-mobile")) {
    //     getSwiper().then((method) => method.SwiperGallery.carouselMobile())
    // }

    // if (document.querySelector(".swiper.timeline")) {
    //     getSwiper().then((method) => method.SwiperGallery.timeline())
    // }
  },
  initBlurhash() {
    const blurhashElements = document.querySelectorAll(".blurhash-loader")
    if (blurhashElements && blurhashElements.length > 0) {
      blurhashElements.forEach((item, index) => {
        getBlurhash().then((method) => method.Blurhash.init(item))
      })
    }
  },
  initNotificationBar() {
    const notificationBar = document.querySelector("#notification-bar")
    if (notificationBar) {
      getNotificationBar().then((method) => method.NotificationBar.init())
    }
  },
  initTooltip() {
    const tooltips = document.querySelectorAll(".info-tooltip")
    if (tooltips && tooltips.length > 0) {
      getTooltip().then((method) => method.Tooltip.init())
    }
  },
  initGateway() {
    const gatewayPage = document.querySelector("#checkout-gateway")
    if (gatewayPage) {
      getGateway().then((method) => method.Gateway.init())
    }
  },
  initOverlayMenus() {
    const overlayLinks = document.querySelectorAll(".js-basket-icon, button[data-enquiry]")
    // console.log('initOverlayMenus: ', overlayLinks)
    if (overlayLinks && overlayLinks.length > 0) {
      overlayLinks.forEach((link) => {
        // console.log(link)
        getNavigation().then((method) => method.OverlayUtility.init(link))
      })
    }
  },
  initAccordion() {
    const accordionElement = document.querySelectorAll(".collapse__title")
    if (accordionElement) {
      accordion()
      autoOpenFirstAccordion()
    }
  },
  initProductDetail() {
    // Setup product-variant url parameter (?vid)
    if (document.documentElement.id === "catalogue-detail") {
      // getProductDetail().then((method) => method.ProductDetail.init())
      getProduct().then((method) => method.UpdateProductDetails.init())
      getProduct().then((method) => method.ProductDetail.stickyAddToBasket())
      getProduct().then((method) => method.CommerceConnector.init())
    }
  },
  initFilters(e) {
    getFilters().then((method) => method.Filters.init(e))

    const catalogueBrowse = document.getElementById("catalogue-browse")
    // if (catalogueBrowse) getFilters().then((method) => method.Filters.filterDrawer(e))
  },
  initProduct() {
    // Activate add to basket methods
    getProduct().then((method) => method.AddToBasket.addEventListeners())
  },
  initQuickShop() {
    const quickShopTriggers = document.querySelectorAll(".js-quickshop-trigger")
    if (quickShopTriggers && quickShopTriggers.length > 0) {
      quickShopTriggers.forEach((trigger) => {
        if (trigger.dataset.minimalQuickshop === "1") return
        trigger.addEventListener("click", (e) =>
          getProduct().then((method) => method.QuickShop.init(e))
        )
      })
    }
  },
  initBasket() {
    if (document.documentElement.id === "basket") {
      const basketQuickview = document.querySelector(".js-basket-quickview")
      const basket = document.querySelector(".basket__container")
      const basketLines = document.querySelector(".js-basket-lines")

      if (basketQuickview && basketLines) {
        getBasket().then((method) => method.Basket.init(basket))
        getBasket().then((method) => method.Basket.updateBasketQuantity(basketLines))
      }
    }
  },
  initBasketQuickview() {
    const basketQuickview = document.querySelector(".js-basket-quickview")
    if (basketQuickview) {
      getBasket().then((method) => method.Basket.updateBasketQuantity(basketQuickview))
      getBasket().then((method) => method.Basket.initQuickshopTriggers(basketQuickview))
      const removeLineButton = basketQuickview.querySelectorAll(".js-basket-line-actions--remove")
      if (removeLineButton && removeLineButton.length > 0) {
        removeLineButton.forEach((button) => {
          button.addEventListener("click", (e) =>
            getBasket().then((method) => method.Basket.removeBasketLine(e))
          )
        })
      }
    }
  },
  initBasketProductDetail() {
    const basketProductDetail = document.querySelector(".product-detail__container")
    if (basketProductDetail) {
      getBasket().then((method) => method.Basket.init(basketProductDetail))
    }
  },
  initShareModal() {
    const shareButton = document.querySelector(".btn--share")
    if (shareButton) getShareModal().then((method) => method.ShareModal.init(shareButton))
  },
  initProductDetailGallery() {
    const swiperGallery = document.querySelectorAll(".js-product-detail-gallery")
    if (swiperGallery && swiperGallery.length > 0) {
      swiperGallery.forEach((gallery, index) => {
        if (index === 0) getSwiper().then((method) => method.SwiperGallery.sliderVertical(gallery))
        getPhotoSwipe().then((method) => method.PhotoSwipe.init())
      })
    }
  },
  initProductVariantsSelect() {
    const customSelect = document.querySelector("select#id_variants")
    if (customSelect) {
      getSlimSelect().then((method) => method.SelectListVariants.init(customSelect))
    }
  },
  // initSubcategoryGallery() {
  //     const subcategoryGallery = document.querySelector(".swiper-container.subcategoryGallery")
  //     if (subcategoryGallery) {
  //         getSwiper().then((method) => {
  //             method.SubcategoryGallery.init(subcategoryGallery)
  //         })
  //     }
  // },
  // initDecosGallery() {
  //     const decosGallery = document.querySelector(".picks .swiper-container.decos")
  //     if (decosGallery) {
  //         getSwiper().then((method) => {
  //             method.DecosGallery.init(decosGallery)
  //         })
  //     }
  // },
  // initWatchesGallery() {
  //     const watchesGallery = document.querySelector(".picks .swiper-container.watches")
  //     if (watchesGallery) {
  //         getSwiper().then((method) => {
  //             method.WatchesGallery.init(watchesGallery)
  //         })
  //     }
  // },
  // initJewelleryGallery() {
  //     const jewelleryGallery = document.querySelector(".picks .swiper-container.jewellery")
  //     if (jewelleryGallery) {
  //         getSwiper().then((method) => {
  //             method.JewelleryGallery.init(jewelleryGallery)
  //         })
  //     }
  // },

  // initRecentlyGallery() {
  //     const recentlyGallery = document.querySelector(".picks .swiper-container.recent")
  //     if (recentlyGallery) {
  //         getSwiper().then((method) => {
  //             method.RecentGallery.init(recentlyGallery)
  //         })
  //     }
  // },
  initNotifications() {
    const notifications = document.querySelectorAll(".js-notifications-outer")
    if (notifications && notifications.length) {
      notifications.forEach((notification) => {
        getNotifications().then((method) => method.Notifications.init(notification))
      })
    }
  },
  initWishlist() {
    const wishListButton = document.querySelectorAll(".js-add-to-favorites")
    if (wishListButton.length > 0) {
      wishListButton.forEach((button) => {
        button.addEventListener("click", (e) =>
          getWishlist().then((method) => method.AddToWishlist.init(e))
        )
      })
    }
  },
  initFieldValidation() {
    const requiredFields = document.querySelectorAll("input[required]")
    if (requiredFields) getCheckout().then((method) => method.FieldValidation.watch())
  },
  initCustomSelect() {
    const customSelect = document.querySelectorAll(
      "select:not(#id_sorting, #id_category, #id_search_fields, #id_variants)"
    )
    if (customSelect && customSelect.length) {
      customSelect.forEach((select) => {
        // getSlimSelect().then(method => method.SelectList.init(select))
      })
    }
  },
  initCheckout() {
    getCheckout().then((method) => method.Checkout.init())
  },
  initDropdown() {
    const dropdown = document.querySelectorAll(".dropdown-list")
    if (dropdown && dropdown.length > 0) {
      dropdown.forEach((list) => getDropdown().then((method) => method.DropDown.init(list)))
    }
  },
  initPlaceholderToLabel() {
    const inputWithTransition = document.querySelectorAll(".placeholder-transition__input")

    if (inputWithTransition && inputWithTransition.length > 0) {
      inputWithTransition.forEach((element) => {
        getPlaceholderToLabel().then((method) => method.PlaceholderToLabel.init(element))
      })
    }
  },
  initAutofillInputPlaceholderToLabel() {
    const autofilledInput = document.querySelectorAll("input:-webkit-autofill")

    if (autofilledInput && autofilledInput.length > 0) {
      autofilledInput.forEach((element) => {
        getPlaceholderToLabel().then((method) =>
          method.AutofillInputPlaceholderToLabel.init(element)
        )
      })
    }
  },
  initFlatpickr() {
    const dateInput = document.querySelector("#id_event_details-event_date")
    // const parent = dateInput.parentNode
    if (dateInput) {
      getFlatpickr().then((method) => method.PickDate.init(dateInput))
      dateInput.setAttribute("autocomplete", "off")
    }
  },
  initSubscribe() {
    // Setup product-variant url parameter (?vid)
    if (document.querySelector(".subscribe-form")) {
      getSubscribe().then((method) => method.Subscribe.init())
    }
  },
  initViewport() {
    document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01 + "px")
    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01 + "px")
    })
  },
  initLookbook() {
    const collection = document.querySelector("#collection-index")
    const look = document.querySelector("#look-index")

    if (collection) {
      getLookbook().then((method) => method.Lookbook.load())
    }

    if (look) {
      getLookbook().then((method) => method.LookDetail.introLoad())
      getLookbook().then((method) => method.LookDetail.initScrollTrigger())

      const lookProductGalleries = document.querySelectorAll(
        ".js-look-detail-product-gallery .lookbook-product-slider"
      )
      if (!lookProductGalleries || lookProductGalleries.length === 0) return
      lookProductGalleries.forEach((gallery) => {
        getSwiper().then((method) => method.SwiperGallery.sliderLookbook(gallery))
      })
    }
  },
  initHeaderNavigation() {
    const header =
      document.querySelector("header.header") || document.querySelector("header.js-fixed-nav")
    if (header) {
      getHeaderNavigation().then((method) => method.HeaderNavigation.init())
    }
  },
  loadFunctions(e) {
    passwordVisibilityToggle()
    accordionWithCaret()
    //Set initial state for different elements
    State.setSearchNavState("search_nav_closed")
    State.setBasketNavState("basket_quickview_closed")
    State.setMainNavState("main_nav_closed")
    State.setModalState("modal_closed")
    State.setFilterModalState("filter_modal_closed")
    State.setQuickshopState("quickshop_closed")

    // Fetch images designated to preload
    const imagesToPreload = document.querySelectorAll("[data-preload].lazyload")

    const preloadImages = (collection) => {
      collection.forEach((el) => {
        const sourceElements = el.querySelectorAll("source")
        sourceElements.forEach((source) => {
          if (source.hasAttribute("data-srcset")) source.srcset = source.getAttribute("data-srcset")
        })
      })
    }

    if (imagesToPreload && imagesToPreload.length > 0) {
      preloadImages(imagesToPreload)
    }

    if (document.documentElement.id !== "checkout-information") {
      getNavigation().then((method) => method.HandleMenuVisibility.toggleMenu())
    }

    window.isMobile = false //initiate as false
    // device detection
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      window.isMobile = true
    }

    window.addEventListener("resize", (e) => {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        window.isMobile = true
      } else {
        window.isMobile = false
      }
    })

    App.initViewport()
    // Activate the shop utility links (basket, search, my account)
    App.initOverlayMenus()
    // Activate Blurhash for image loading
    App.initBlurhash()
    // Activate accordion
    App.initAccordion()
    // Activate notifications
    App.initNotifications()
    // Activate custom select lists
    App.initCustomSelect()
    // Activate Shopping Basket
    App.initBasket()
    // Activate product methods
    App.initProduct()
    // Activate Quick Shop Function
    App.initQuickShop()
    // Activate Swiper
    App.initSwiper()
    // Activate the Basket Quickview Function
    App.initBasketQuickview()
    //Activate multiple form submission when adding all to table
    // App.initBasketProductDetail()
    //Activate the Product Detail General Functions (variant-url)
    App.initProductDetail()
    //Activate the filters General Functions
    // App.initFilters(e)
    // Activate the share modal
    App.initShareModal()
    // Activate the swiper gallery
    App.initProductDetailGallery()
    // Activate the product detail variant select list
    App.initProductVariantsSelect()
    // Activate the decos products gallery
    // App.initSubcategoryGallery()
    // App.initDecosGallery()
    // Activate the watches products gallery
    // App.initWatchesGallery()
    // Activate the jewellery products gallery
    // App.initJewelleryGallery()
    // App.initRecommendedGallery()
    // App.initRecentlyGallery()
    // Activate Wishlist function
    App.initWishlist()
    // Activate Field Validation
    // App.initFieldValidation()
    App.initCheckout()

    // Activate custom dropdown element
    App.initDropdown()
    App.initPlaceholderToLabel()
    App.initAutofillInputPlaceholderToLabel()
    // Init Flatpickr datepicker
    App.initFlatpickr()
    // Init Gateway
    App.initGateway()
    // Init Information:
    // Init tooltip
    App.initTooltip()
    // Init NotificationBar
    App.initNotificationBar()
    // Init subscribe
    App.initSubscribe()
    // Init Lookbook
    App.initLookbook()
    // Init Header Navigation
    App.initHeaderNavigation()
  },
  initLazyImages() {
    // Lazy load images using the Intersection Observer. Started on DOMContentLoaded:
    // waiting for window "load" held back the product list images until every other
    // resource on the page (menu banners, newsletter background, fonts) had finished.
    getIolazy().then((method) => {
      method.default.init()
      // htmx swaps inject markup after init(), so the observer never sees it.
      document.body.addEventListener("htmx:afterSwap", (e) => method.default.refresh(e.target))
    })
  },
  windowLoadFunctions() {
    // Pick up any .lazyload nodes other scripts added after DOMContentLoaded
    // (e.g. Swiper loop clones). Re-observing an already loaded image is harmless.
    getIolazy().then((method) => method.default.refresh())
  },
}

const refreshListeners = () => {
  App.initQuickShop()
  App.initSwiper()
}

window.refreshListeners = refreshListeners

document.addEventListener("DOMContentLoaded", App.loadFunctions.bind(this))
// After loadFunctions, so markup it builds synchronously is already in the DOM
document.addEventListener("DOMContentLoaded", App.initLazyImages)
window.addEventListener("load", App.windowLoadFunctions)
